import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FilterListIcon from '@mui/icons-material/FilterList';
import './FilterToggle.scss';

export default function FilterToggle({ isOpen, onToggle }) {
  return (
    <div className={`filter-toggle ${isOpen ? 'open' : 'closed'}`}>
      <IconButton
        onClick={onToggle}
        className="toggle-button"
        size="large"
        aria-label={isOpen ? 'Close filters' : 'Open filters'}
      >
        {isOpen ? (
          <ChevronLeftIcon />
        ) : (
          <div className="filter-button-content">
            <FilterListIcon />
            <span className="filter-text">Filters</span>
          </div>
        )}
      </IconButton>
    </div>
  );
}
